/* File to contain the Axios base and create the
   axiosReq and axiosRes */

import axios from "axios";
// import { getCookie } from "../utils/utils"

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

// Must be set before the axios.create() calls below: they snapshot these
// defaults at creation time and ignore later changes.
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
axios.defaults.withCredentials = true;

export const axiosReq = axios.create();
export const axiosRes = axios.create();

const csrfToken = getCookie("csrftoken") ? getCookie("csrftoken") : null;

// Create headers object with or without the Authorization header
const csrfHeader = {};
if (csrfToken) {
  csrfHeader["X-CSRFToken"] = csrfToken;
}

// For Protect API route use this api instance of axios
export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    ...csrfHeader,
  },
  withCredentials: true,
});
export const axiosInstanceFormData = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
    ...csrfHeader,
  },
  withCredentials: true,
});

export const setAuthToken = (token) => {
  if (token) {
    const authHeader = `Bearer ${token}`;
    axios.defaults.headers.common.Authorization = authHeader;
    axiosInstance.defaults.headers.common.Authorization = authHeader;
    axiosInstanceFormData.defaults.headers.common.Authorization = authHeader;
    return;
  }

  delete axios.defaults.headers.common.Authorization;
  delete axiosInstance.defaults.headers.common.Authorization;
  delete axiosInstanceFormData.defaults.headers.common.Authorization;
};

setAuthToken(localStorage.getItem("accessToken"));

const attachAuthToken = (config) => {
  const token = localStorage.getItem("accessToken");
  config.headers = config.headers || {};

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }

  return config;
};

axiosInstance.interceptors.request.use(attachAuthToken);
axiosInstanceFormData.interceptors.request.use(attachAuthToken);

// used when No Authorization token is required----------------------------------------------------------------
export const axiosInstanceNoAuth = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    ...csrfHeader,
  },
  withCredentials: true,
});
export const axiosInstanceNoAuthFormData = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
    ...csrfHeader,
  },
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (result) => {
    return { success: true, data: result };
  },
  (error) => {
    console.log("INTERCEPTOR ERROR", error.response);
    if (error.response?.status === 440) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("user");

      window.location.href = `/signin`;
    }
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("user");

      window.location.href = `/signin`;
    }
    return Promise.resolve({ success: false, error });
  }
);
axiosInstanceFormData.interceptors.response.use(
  (result) => {
    return { success: true, data: result };
  },
  (error) => {
    if (error?.response?.status === 401) {
      return Promise.resolve({ success: false, error });
    }
    return Promise.resolve({ success: false, error });
  }
);
